<template>
  <px-custom-dialog v-model="dialog" width="700">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on"></slot>
    </template>
    <template v-slot:title>
      Campos da entidade {{ entidade.nome }}
    </template>
    <template v-if="dialog">
      <div class="mt-4" v-for="(camposPorCadastro, index) in cadastros"  v-bind:key="index">
        <h3>{{ camposPorCadastro[0].cadastro.nomeExibicao }}</h3>
        <v-row>
          <v-col>Nome exibição</v-col>
          <v-col class="text-center">Visível</v-col>
          <v-col class="text-center">Requerido</v-col>
          <v-col class="text-center">Bloquear edição</v-col>
        </v-row>
        <v-row
          v-for="campo in camposPorCadastro"
          v-bind:key="campo.cadastroCampo"
          dense>

          <v-col>
            <v-text-field
              outlined
              required
              hide-details
              dense
              maxlength="120"
              class="required"
              v-model="campo.nomeExibicao"
             >
             <template v-slot:append>
              <v-tooltip bottom v-if="campo.nomeExibicao!=campo.campo.nomeExibicaoPadrao">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                Padrão: {{campo.campo.nomeExibicaoPadrao}}
                <v-icon>
                  mdi-help-circle-outline
                </v-icon>
              </v-tooltip>
            </template>
            </v-text-field>
          </v-col>
          <v-col class="d-flex justify-center align-center">
            <v-switch class="my-0" v-model="campo.visivel" hide-details dense></v-switch>
          </v-col>
          <v-col class="d-flex justify-center align-center">
            <v-switch class="my-0" v-model="campo.requerido" hide-details dense></v-switch>
          </v-col>
          <v-col class="d-flex justify-center align-center">
            <v-switch
                class="my-0"
                v-model="campo.bloquearEdicao"
                hide-details
                dense></v-switch>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
      </div>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <div class="mt-5">
        <v-btn color="primary"
               @click="save"
               :loading="loading">
          Salvar
        </v-btn>
        <v-btn text @click="close">Cancelar</v-btn>
      </div>
    </template>
  </px-custom-dialog>
</template>

<script>
import { chain } from 'lodash';
import validationMixin from '@/mixins/validation-mixin';
import { required, maxLength } from 'vuelidate/lib/validators';
import ControleCampoService from './controle-campo-service';

export default {
  mixins: [validationMixin],
  props: {
    entidade: Object,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      campos: [],
    };
  },
  computed: {
    cadastros() {
      return chain(this.campos)
        .orderBy(['cadastro.nomeExibicao', 'asc', 'campo.nomeExibicaoPadrao', 'asc'])
        .groupBy('cadastro.key')
        .value();
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    save() {
      if (this.validateForm()) {
        return;
      }

      this.loading = true;

      const camposSemId = this.campos.map((campo) => ({
        ...campo,
        id: campo.id || undefined,
      }));

      ControleCampoService.save(this.entidade.id, camposSemId)
        .then(() => {
          this.$toast('Campos configurados com sucesso', { color: 'success' });
          this.close();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.campos = [];
        return;
      }
      ControleCampoService.findByEntidade(this.entidade.id)
        .then(({ data }) => {
          this.campos = data;
        });
    },
  },
  validations: {
    campos: {
      $each: {
        nomeExibicao: {
          required,
          maxLength: maxLength(120),
        },
        visivel: {},
        requerido: {},
        bloquearEdicao: {},
      },
    },
  },
};
</script>
